import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ClickOutsideModule } from 'ng-click-outside';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TabsModule } from 'primeng/tabs';
import { DatePickerModule } from 'primeng/datepicker';
import { TooltipModule } from 'primeng/tooltip';

import { AccountManagementComponent } from './components/account-management.component';
import { QuotaPreferencesComponent } from './components/QuotaPreferences/quota-preferences.component';
import { SocialPreferencesComponent } from './components/SocialPreferences/social-preferences.component';
import { ProvidersPreferencesComponent } from './components/ProvidersPreferences/providers-preferences.component';
import { TargetingPreferencesComponent } from './components/TargetingPreferences/targeting-preferences.component';
import { BroadcastPreferencesComponent } from './components/BroadcastPreferences/broadcast-preferences.component';
import { NewswirePreferencesComponent } from './components/NewswirePreferences/newswire-preferences.component';
import { AdminAccountPreferencesComponent } from './components/AccountPreferences/admin-account-preferences.component';
import { UserProfileComponent } from './components/UserProfile/user-profile.component';
import { UserProfilePageComponent } from './components/UserProfile/UserProfilePage/user-profile-page.component';
import { UserProfileDialogComponent } from './components/UserProfile/UserProfileDialog/user-profile-dialog.component';
import { ActivityComponent } from './components/UserProfile/UserProfilePage/ActivityLog/activity-log.component';
import { MonitoringPreferencesComponent } from './components/MonitoringPreferences/monitoring-preferences.component';
import { MediaMonitoringApiKeyCardComponent } from './components/MonitoringPreferences/MediaMonitoringApiKeyCard/media-monitoring-api-key-card.component';
import { PermissionManagementComponent } from './components/PermissionManagement/permission-management.component';
import { AccountNotesComponent } from './components/AccountNotes/account-notes.component';
import { CustomPromptsManagementDialogComponent } from './components/CustomPromptsManagement/custom-prompts-management-dialog.component';

import { PreferencesRegionSelectDialogService } from './services/preferences-region-select-dialog.service';
import { PreferenceCountrySelectDialogService } from './services/preference-country-select-dialog.service';
import { ApiKeyService } from './services/api-key.service';

import { PageBuilderModule } from '../../Common/PageBuilder/page-builder.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { JournodexRegionsService } from '../../Common/Journodex/services/journodex-regions.service';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { LoginApi } from '../../api/login/login.api';
import { MediaSubscriptionPreferenceService } from './services/media-subscription-preference.service';
import { UserPreferencesModule } from '../../Account/UserPreferences/user-preferences.module';
import { UnsavedExportPreferencesComponent } from './components/UnsavedExportPreferences/unsaved-export-preferences.component';
import { BriefingConfigPreferencesComponent } from './components/BriefingConfigPreferences/briefing-config-preferences.component';
import { ManageApiKeysDialogComponent } from './components/ApiKeysManagement/manage-api-keys-dialog.component';
import { FilterModule } from '../../Common/Filter/filter.module';
import { TakeOverModule } from '../../Common/TakeOver/take-over.module';
import { AIAgentQuotaAdminApiService } from '../../api/agents/AI-agent-quota-admin.api.service';
import { AccountNoteApi } from '@api/accountNote/accountNote.api';

@NgModule({
    imports: [
        LocalizationModule,
        PageBuilderModule,
        TabsModule,
        CommonModule,
        FormsModule,
        ButtonModule,
        MiscModule,
        ClickOutsideModule,
        CommonFormsModule,
        LayoutModule,
        AutoCompleteModule,
        SelectModule,
        InputTextModule,
        CheckboxModule,
        CommonBasicModule,
        TooltipModule,
        CoreDialogsModule,
        DatePickerModule,
        UserPreferencesModule,
        FilterModule,
        TakeOverModule
    ],
    declarations: [
        AccountManagementComponent,
        PermissionManagementComponent,
        QuotaPreferencesComponent,
        SocialPreferencesComponent,
        ProvidersPreferencesComponent,
        TargetingPreferencesComponent,
        BroadcastPreferencesComponent,
        NewswirePreferencesComponent,
        AdminAccountPreferencesComponent,
        UserProfileComponent,
        UserProfilePageComponent,
        ActivityComponent,
        UserProfileDialogComponent,
        MonitoringPreferencesComponent,
        MediaMonitoringApiKeyCardComponent,
        UnsavedExportPreferencesComponent,
        BriefingConfigPreferencesComponent,
        AccountNotesComponent,
        ManageApiKeysDialogComponent,
        CustomPromptsManagementDialogComponent
    ],
    exports: [
        AccountManagementComponent,
        ManageApiKeysDialogComponent,
        CustomPromptsManagementDialogComponent
    ],
    providers: [
        JournodexRegionsService,
        LoginApi,
        PreferencesRegionSelectDialogService,
        PreferenceCountrySelectDialogService,
        MediaSubscriptionPreferenceService,
        AccountNoteApi,
        ApiKeyService,
        AIAgentQuotaAdminApiService
    ]
})
export class AccountManagementModule { }
